import { ButtonProps } from '@material-ui/core';

interface CtaButtonConfig {
    styles: {
        button: {
            color: ButtonProps['color'];
            variant: ButtonProps['variant'];
        };
    };
}

export interface AlmeCtaButtonConfig {
    ctaButton: CtaButtonConfig;
}

const defaultConfig: AlmeCtaButtonConfig = {
    ctaButton: {
        styles: {
            button: {
                color: 'secondary' as const,
                variant: 'contained' as const,
            },
        },
    },
};

export default defaultConfig;